module.exports = __webpack_public_path__ + "static/43gde-fafdac6ed1f552a2e59d05031eb11341.gif";